import { Box, Checkbox, TableRow, Typography } from '@mui/material';
import { ChangeEvent, Fragment } from 'react';
import { StyledHeaderCell } from '../styles';
import { TableProps } from '../types';
import HelperTooltip from '../../../../../../../../../../shared/HelperTooltip/HelperTooltip';
import linksConfig from '../../../../../../../../../../config/linking';

export const renderColumns = ({
  shouldDisableCheckAll,
  handleToggleAll,
  columns,
}: {
  columns: TableProps['columns'];
  shouldDisableCheckAll: boolean;
  handleToggleAll: (event: ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <TableRow>
      <StyledHeaderCell padding="checkbox">
        <Checkbox
          color="primary"
          disabled={shouldDisableCheckAll}
          onChange={handleToggleAll}
        />
      </StyledHeaderCell>
      {columns.map(({ key, label, width, align, padding }) => {
        return (
          <Fragment key={key}>
            <StyledHeaderCell sx={{ width, padding }} align={align}>
              <Box display="inline-flex" alignItems="center">
                <Typography
                  textAlign="right"
                  color="textDark.main"
                  variant="caption"
                  textTransform="uppercase"
                  fontWeight={600}
                >
                  {label}
                </Typography>
                {key === 'format' && (
                  <HelperTooltip
                    tooltipData={linksConfig.checkTypesDefinitions}
                    sx={{
                      marginLeft: '24px',
                      paddingBottom: 0,
                      top: '-7px',
                      position: 'relative',
                      width: 'fit-content',
                    }}
                  />
                )}
              </Box>
            </StyledHeaderCell>
          </Fragment>
        );
      })}
    </TableRow>
  );
};
